import React, {Component} from "react";
import {Checkbox} from "antd";
import {injectIntl} from "react-intl";
import BoldText from "../../../common/text/BoldText";
import {connect} from "react-redux";
import * as types from "../../../../constants/ActionTypes";
import {getFilters} from "../../../../selectors/fetchInterventions";

const CheckboxGroup = Checkbox.Group;

const EMPTY_VALUE = '__EMPTY__';

class FilterCheckbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAll: false,
      selectedFilters: [],
    }
  }

  getOptions = () => {
    const options = [...this.props.options];
    if (this.props.emptyValueFilter) {
      options.unshift({label: `(${this.props.intl.formatMessage({id: 'none'})})`, value: EMPTY_VALUE});
    }
    return options;
  }

  componentDidMount() {
    this.setFilters();
  }

  componentDidUpdate(prevProps) {
    const {filters} = this.props;
    if (prevProps.filters !== filters) {
      this.setFilters();
    }
  }

  setFilters = () => {
    const {filters, apiKey} = this.props;
    this.setState({
      selectedFilters: filters[apiKey],
      selectedAll: filters[apiKey] && filters[apiKey].length === this.getOptions().length
    });
  }

  filterOnChange = (checkedValues) => {
    this.setState({selectedFilters: checkedValues});
  };

  filterConfirm = () => {
    const {apiKey, filter, contentUpdater, dispatchSetFilters, filters} = this.props;
    const {selectedFilters} = this.state;
    filter.selectedKeys[0] = selectedFilters;
    const map = {};
    map[apiKey] = selectedFilters;
    const newFilters = {...filters};
    newFilters[apiKey] = selectedFilters;
    dispatchSetFilters(newFilters);
    (selectedFilters && selectedFilters.length > 0) ? filter.confirm() : filter.clearFilters()
    contentUpdater(map);
  };

  filterSelectAll = () => {
    const {selectedAll} = this.state;
    this.setState({
      selectedFilters: !selectedAll ? this.getOptions().map(i => i.value) : [],
      selectedAll: !selectedAll,
    })
  };

  render = () => {
    const options = this.getOptions();
    const {intl: {formatMessage}} = this.props;
    const {selectedFilters, selectedAll} = this.state;

    return (
      <div className="dropdown dropdown--sm dropdown--bottom-right">
        <div className="dropdown--checkbox">
          <Checkbox checked={selectedAll} onClick={this.filterSelectAll}>
            <BoldText text={`(${formatMessage({id: 'intervention.status.ALL'})})`}/>
          </Checkbox>
        </div>
        <CheckboxGroup
          value={selectedFilters}
          onChange={(values) => this.filterOnChange(values)}
          options={options}
        />
        <div className="dropdown--checkbox">
          <button
            type="primary"
            className="btn btn-outline"
            onClick={this.filterConfirm}
          >
            {formatMessage({id: 'menu.apply'})}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInterventions: state.fetchInterventions,
  filters: getFilters(state),
});

const mapDispatchToProps = dispatch => ({
  dispatchSetFilters: (filters) => dispatch({type: types.SET_FILTERS, filters}),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FilterCheckbox));



// WEBPACK FOOTER //
// ./src/components/overview/table/filter/FilterCheckbox.js